// extracted by mini-css-extract-plugin
module.exports = {"cards":"article_group_1-module--cards--21BWz","card":"article_group_1-module--card--2_EvG","title":"article_group_1-module--title--2xILh"};